import _ from 'lodash';

//* 국내 휴대폰 번호 판정. 백엔드 common/phone.util.ts의 isMobilePhone과 같은 기준 — 어긋나면 서버가
//* 로그인 문자 인증(PHONE_NOT_REGISTERED)·번호 저장에서 다르게 판정한다. 하이픈·공백은 무시한다.
export const isMobilePhoneNumber = (value?: string | null): boolean =>
  /^01[016789]\d{7,8}$/.test((value ?? '').replace(/\D/g, ''));

export const phoneNumberStringFormator = (s: string | undefined, arr?: any): string => {
  if (_.isUndefined(s)) return '';
  s = s.replace(/-/gi, '');
  let j = 0;
  let out = '';
  if (arr) {
    for (let i = 0; i < s.length; i++) {
      if (j < arr.length && i >= arr[j]) {
        out = out + '-';
        j = j + 1;
      }
      out = out + s[i];
    }
    return out;
  } else {
    arr = s.length === 10 ? [3, 6] : [3, 7];
    for (let i = 0; i < s.length; i++) {
      if (j < arr.length && i >= arr[j]) {
        out = out + '-';
        j = j + 1;
      }
      out = out + s[i];
    }
    return out;
  }
};

export const callNumberStringFormater = (s: string | undefined, arr?: any): string => {
  if (_.isUndefined(s)) return '';
  s = s.replace(/-/gi, '');
  let j = 0;
  let out = '';
  if (arr) {
    for (let i = 0; i < s.length; i++) {
      if (j < arr.length && i >= arr[j]) {
        out = out + '-';
        j = j + 1;
      }
      out = out + s[i];
    }
    return out;
  } else {
    if (s.slice(0, 2) === '02') {
      arr = s.length === 9 ? [2, 5] : [2, 6];
      for (let i = 0; i < s.length; i++) {
        if (j < arr.length && i >= arr[j]) {
          out = out + '-';
          j = j + 1;
        }
        out = out + s[i];
      }
      return out;
    } else {
      arr = s.length === 10 ? [3, 6] : [3, 7];
      for (let i = 0; i < s.length; i++) {
        if (j < arr.length && i >= arr[j]) {
          out = out + '-';
          j = j + 1;
        }
        out = out + s[i];
      }
      return out;
    }
  }
};
